module.exports = __webpack_public_path__ + "img/share_tips.122415b9.png";